import * as React from 'react';
import { FC, Suspense } from 'react';

import { useEffectOnce } from '@legendapp/state/react';

import { useMediaData } from './hooks/use-media-data';

import App from './components/app/App';
import EditorMode from './components/editor-mode';
import { nbaStore } from './store/stores/nba-store';

interface AppProps {
	readonly isEditorMode: boolean;
}

type Props = AppProps;

const AppComponent: FC<Props> = ({ isEditorMode }) => {
	useMediaData();

	// Set NBAB here - why? render of CMS loading spinner :(
	useEffectOnce(() => {
		nbaStore.subscribeToAllNBATransfers();
		return () => nbaStore.unsubscribeToAllNBATransfers();
	}, []);

	if (isEditorMode) {
		return <EditorMode />;
	}

	return (
		<Suspense fallback={<></>}>
			<App />
		</Suspense>
	);
};

export default AppComponent;
